import { render, staticRenderFns } from "./UserProjectProfile.vue?vue&type=template&id=356c1f0b&"
import script from "./UserProjectProfile.vue?vue&type=script&lang=js&"
export * from "./UserProjectProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports